import Icon from '../components/Icon.vue'

Icon.register({
  'map-signs': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M507.3 84.7L464 41.4C458 35.4 449.9 32 441.4 32H288V16C288 7.2 280.8 0 272 0H240C231.2 0 224 7.2 224 16V32H56C42.8 32 32 42.8 32 56V136C32 149.3 42.8 160 56 160H441.4C449.9 160 458 156.6 464 150.6L507.3 107.3C513.6 101.1 513.6 90.9 507.3 84.7zM224 496C224 504.8 231.2 512 240 512H272C280.8 512 288 504.8 288 496V384H224V496zM456 224H288V192H224V224H70.6C62.1 224 54 227.4 48 233.4L4.7 276.7C-1.6 282.9-1.6 293.1 4.7 299.3L48 342.6C54 348.6 62.1 352 70.6 352H456C469.3 352 480 341.3 480 328V248C480 234.8 469.3 224 456 224z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/map-signs.js
// module id = dhGt
// module chunks = 144